import {
  ActionIcon,
  Badge,
  Box,
  Button,
  Flex,
  Grid,
  LoadingOverlay,
  NumberInput,
  SegmentedControl,
  Select,
  Table,
  Text,
  TextInput,
  Textarea,
  Tooltip,
  Autocomplete,
} from "@mantine/core";
import { DatePickerInput } from "@mantine/dates";
import { useDebouncedState, useDisclosure } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import {
  IconArrowLeft,
  IconCheck,
  IconDeviceDesktop,
  IconPlus,
  IconTrash,
  IconX,
  IconList,
} from "@tabler/icons-react";
import { useEffect, useMemo, useRef, useState } from "react";
import { repositoryMdm, repositoryPos } from "../../_base/_const/_constVar";
import { NotificationExtension } from "../../_base/extension/NotificationExtension";
import { MessageResponse } from "../../model/MessageResponse";
import {
  getProvinceSelectNew,
  getCommuneSelectNew,
  getItemPositionSelect,
  getBranchSelect,
  getTblDmSaleChanelSelect,
  getTblDmProcessingMethodSelect,
} from "../../service/getSelectApi";
import styles from "./CreateServiceRepairForm.module.css";
import ListCustMeetingInfomation from "../Warranty/ReceiveWarranty/ListCustMeetingInfomation";
import {
  startOfDay,
  diffDaysFromBase,
  dateFromDays,
  minScheduleDate,
  isDaysReturnInvalid,
  isScheduleTimeInvalid,
  hasDaysReturnError,
  hasScheduleTimeError,
  DAYS_RETURN_INVALID_MESSAGE,
  scheduleTimeInvalidMessage,
} from "./scheduleReturnValidation";

interface DeviceItem {
  id: number;
  itemId?: number | null;
  productName: string;
  itemCode: string;
  serial: string;
  serviceType: string;
  orderCode: string;
  amount: number;
  faultDescription: string;
  testingStatus: string;
  accessories: string;
  scheduleTime: string | null;
  daysReturn: number | null;
  quotation: string;
}

const emptyDevice = (id: number): DeviceItem => ({
  id,
  itemId: null,
  productName: "",
  itemCode: "",
  serial: "",
  serviceType: "Sửa có phí",
  orderCode: "",
  amount: 1,
  faultDescription: "",
  testingStatus: "Chờ test",
  accessories: "",
  scheduleTime: null,
  daysReturn: null,
  quotation: "",
});

const CreateServiceRepairForm = ({ onClose, onSuccess, onSaved }: any) => {
  const [visible, { close, open }] = useDisclosure(false);
  const [phoneSearch, setPhoneSearch] = useState("");
  const [customerSearchData, setCustomerSearchData] = useState<any[]>([]);
  const [rawCustomerRes, setRawCustomerRes] = useState<any[]>([]);
  const [employeeInfo, setEmployeeInfo] = useState<any>(null);
  const [customerData, setCustomerData] = useState<any>(null);

  const openRequestListModal = () => {
    modals.open({
      title: "Danh sách đăng ký dịch vụ sửa chữa",
      size: "80%",
      children: (
        <ListCustMeetingInfomation
          view="EDIT"
          setDataMeetingAddress={(data: any) => {
            setCustomerData((prev: any) => ({
              ...prev,
              customerName: data.custMeeting,
              telephoneNumber: data.custPhone,
              provinceId: data.province,
              districtId: data.district,
              communeId: data.commune,
              address: data.additionalAddress,
              customerGroup: "KHACH_LE",
            }));
          }}
          infoCust={(cb: any) => {
            const data = typeof cb === "function" ? cb({}) : cb;
            setCustomerData((prev: any) => ({
              ...prev,
              id: data.custId,
            }));
          }}
          setProvinceId={() => {}}
          setDistrictId={() => {}}
          setCommuneId={() => {}}
        />
      ),
    });
  };

  const [devices, setDevices] = useState<DeviceItem[]>([]);
  const lastTagRef = useRef<HTMLElement>(null);
  const [deviceViewMode, setDeviceViewMode] = useState<string>("table");
  const [nextId, setNextId] = useState(1);
  const [errorNumber, setErrorNumber] = useState("");
  const [note, setNote] = useState("");

  // Warehouse & Branch
  const [branchData, setBranchData] = useState<any[]>([]);
  const [selectedBranch, setSelectedBranch] = useState<string | null>(null);
  const [inventoryCode, setInventoryCode] = useState<string | null>(null);
  const [inventoryId, setInventoryId] = useState<number | null>(null);
  const [dataInventorySelect, setDataInventorySelect] = useState<any[]>([]);
  const [idItemPosition, setIdItemPosition] = useState<string | null>(null);
  const [dataItemPositionSelect, setDataItemPositionSelect] = useState<any[]>(
    [],
  );

  // Channel, Processing Method, Customer Group
  const [channelData, setChannelData] = useState<any[]>([]);
  const [selectedChannel, setSelectedChannel] = useState<string | null>(
    "Khách đến showroom",
  );
  const [processingMethodData, setProcessingMethodData] = useState<any[]>([]);
  const [selectedProcessingMethod, setSelectedProcessingMethod] = useState<
    string | null
  >(null);
  const [customerGroupData, setCustomerGroupData] = useState<any[]>([]);
  const [selectedCustomerGroup, setSelectedCustomerGroup] = useState<
    string | null
  >(null);

  // Customer manual fields
  const [custName, setCustName] = useState("");
  const [custPhone, setCustPhone] = useState("");
  const [custAddress, setCustAddress] = useState("");

  // Province / Commune
  const [provinceData, setProvinceData] = useState<any[]>([]);
  const [communeData, setCommuneData] = useState<any[]>([]);
  const [selectedProvince, setSelectedProvince] = useState<string | null>(null);
  const [selectedCommune, setSelectedCommune] = useState<string | null>(null);

  const userLogin = JSON.parse(localStorage.getItem("userLogin") || "{}");

  // Chi nhánh mặc định của nhân viên, BE suy ra từ phòng ban (TBL_DEPARTMENT.BRANCH_ID).
  // Có chi nhánh mặc định là khoá ô, không cho chọn tay.
  const defaultBranchId = employeeInfo?.branchId
    ? String(employeeInfo.branchId)
    : null;
  const isBranchLocked = !!defaultBranchId;

  // Danh sách chi nhánh chỉ liệt kê pháp nhân DVT. Nếu chi nhánh mặc định nằm ngoài danh sách đó
  // thì thêm vào để ô còn hiển thị được tên, nếu không sẽ khoá vào một ô trống.
  const branchOptions = useMemo(() => {
    if (
      !defaultBranchId ||
      branchData.some((item: any) => item.value === defaultBranchId)
    )
      return branchData;

    return [
      ...branchData,
      {
        value: defaultBranchId,
        label: employeeInfo?.branchName || defaultBranchId,
      },
    ];
  }, [branchData, defaultBranchId, employeeInfo?.branchName]);

  // Tự điền chi nhánh mặc định ngay khi có thông tin nhân viên
  useEffect(() => {
    if (!defaultBranchId || selectedBranch === defaultBranchId) return;
    setSelectedBranch(defaultBranchId);
    setInventoryCode(null);
    setInventoryId(null);
    setIdItemPosition(null);
  }, [defaultBranchId, selectedBranch]);

  // Load provinces and branches on mount
  useEffect(() => {
    getProvinceSelectNew().then((data) => {
      setProvinceData(
        (data || [])
          .filter((i: any) => i.id !== undefined && i.id !== null)
          .map((i: any) => ({ value: String(i.id), label: i.name || "N/A" })),
      );
    });
    getBranchSelect().then((res) => {
      if (res) {
        setBranchData(
          res
            .filter((item: any) => item.attr6 === "DVT")
            .map((item: any) => ({
              value: item.value?.toString() || "",
              // Hiển thị "Mã CN - Tên CN" (att2 = mã chi nhánh)
              label: item.att2
                ? `${item.att2} - ${item.text}`
                : item.text || "",
            })),
        );
      }
    });
    // Load channel, processing method, customer group
    getTblDmSaleChanelSelect().then((res: any) => {
      if (res) {
        setChannelData(
          res
            .filter((item: any) => item.text || item.name)
            .map((item: any) => ({
              value: item.text || item.name,
              label: item.text || item.name,
            })),
        );
      }
    });
    getTblDmProcessingMethodSelect().then((res: any) => {
      if (res) {
        const mapped = res
          .filter((item: any) => item.value && (item.text || item.name))
          .map((item: any) => ({
            value: item.value?.toString(),
            label: item.text || item.name,
          }));
        setProcessingMethodData(mapped);
        // Set default: "Xử lý tại CH/CN"
        const defaultPM = mapped.find(
          (i: any) => i.label === "Xử lý tại CH/CN",
        );
        if (defaultPM) setSelectedProcessingMethod(defaultPM.value);
      }
    });
    repositoryMdm
      .get<MessageResponse<any[]>>("/api/v1/TblWarrantyCustomerGroup/get-all")
      .then((res: any) => {
        if (res?.success && res.data) {
          const mapped = res.data
            .filter(
              (item: any) =>
                (item.value || item.Value) && (item.text || item.Text),
            )
            .map((item: any) => ({
              value: item.value || item.Value,
              label: item.text || item.Text,
            }));
          setCustomerGroupData(mapped);
          // Set default: "BH dịch vụ"
          const defaultCG = mapped.find((i: any) => i.label === "BH dịch vụ");
          if (defaultCG) setSelectedCustomerGroup(defaultCG.value);
        }
      });
  }, []);

  // Load communes when province changes
  useEffect(() => {
    if (selectedProvince) {
      getCommuneSelectNew(selectedProvince).then((data) => {
        setCommuneData(
          (data || [])
            .filter((i: any) => i.value !== undefined && i.value !== null)
            .map((i: any) => ({
              value: String(i.value),
              label: i.text || "N/A",
            })),
        );
      });
    } else {
      setCommuneData([]);
    }
  }, [selectedProvince]);

  const customerSearchTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  const handleCustomerSearch = (val: string) => {
    if (val.includes(" - ")) return;
    setPhoneSearch(val);
    if (customerSearchTimeoutRef.current)
      clearTimeout(customerSearchTimeoutRef.current);
    if (!val || val.length < 3) {
      setCustomerSearchData([]);
      return;
    }
    customerSearchTimeoutRef.current = setTimeout(async () => {
      try {
        const res = await repositoryMdm.get<MessageResponse<any[]>>(
          `api/v1/ServiceRepair/search-warranty-customer?keyword=${val}`,
        );
        if (res?.success && res.data) {
          setRawCustomerRes(res.data);
          const opts = res.data.map(
            (c: any) =>
              `${c.telephoneNumber || ""} - ${c.customerName || "Khách lẻ"}`,
          );
          setCustomerSearchData(Array.from(new Set(opts)));
        }
      } catch (e) {
        console.error(e);
      }
    }, 300); // 300ms debounce
  };

  const submitCustomerSearch = (val: string) => {
    const found = rawCustomerRes.find(
      (c) =>
        `${c.telephoneNumber || ""} - ${c.customerName || "Khách lẻ"}` ===
          val ||
        c.telephoneNumber === val ||
        c.requestNum === val ||
        c.customerName === val,
    );
    if (found) {
      setCustomerData(found);
      setPhoneSearch(
        found.telephoneNumber || found.customerName || found.requestNum || "",
      );
    } else if (rawCustomerRes.length > 0) {
      setCustomerData(rawCustomerRes[0]);
      setPhoneSearch(
        rawCustomerRes[0].telephoneNumber ||
          rawCustomerRes[0].customerName ||
          rawCustomerRes[0].requestNum ||
          "",
      );
    }
  };

  useEffect(() => {
    if (customerData) {
      setCustName(customerData.customerName || "");
      setCustPhone(customerData.telephoneNumber || "");
      setCustAddress(customerData.address || "");
      if (customerData.provinceId)
        setSelectedProvince(String(customerData.provinceId));
      if (customerData.communeId)
        setSelectedCommune(String(customerData.communeId));
      if (customerData.customerGroup)
        setSelectedCustomerGroup(customerData.customerGroup);
      if (customerData.attribute14)
        setSelectedProcessingMethod(customerData.attribute14);
      if (customerData.attribute15)
        setSelectedChannel(customerData.attribute15);
    }
  }, [customerData]);

  // Load inventory
  useEffect(() => {
    if (selectedBranch) {
      repositoryPos
        .get<
          MessageResponse<any>
        >(`/api/v1/TblDmInventory/get-select-by-branch?branchId=${selectedBranch}`)
        .then((res) => {
          if (res?.success) {
            setDataInventorySelect(
              res.data
                ?.filter(
                  (i: any) =>
                    i.inventoryId &&
                    i.inventoryName &&
                    (i.inventoryCode.includes("BH") ||
                      i.inventoryCode.includes("DV") ||
                      i.inventoryCode.includes("BK")),
                )
                ?.map((i: any) => ({
                  value: i.inventoryCode?.toString(),
                  label: `${i.inventoryCode} - ${i.inventoryName}`,
                  inventoryId: i.inventoryId,
                })) || [],
            );
          }
        });
    } else {
      setDataInventorySelect([]);
      setInventoryCode(null);
      setInventoryId(null);
    }
  }, [selectedBranch]);

  // Load item positions
  useEffect(() => {
    if (inventoryCode) {
      getItemPositionSelect(inventoryCode).then((data: any) => {
        if (!data) return;
        const mapped = data
          .filter((i: any) => i.id && i.positionName)
          .map((i: any) => ({
            value: i.id?.toString(),
            label: `${i.positionCode} - ${i.positionName}`,
            // Cờ "Lên bảng kê hàng lỗi" của vị trí — hàng nhập vào vị trí chưa bật cờ này
            // sẽ không hiện trên bảng kê hàng dịch vụ
            attribute4: i.attribute4,
          }));
        setDataItemPositionSelect(mapped);
        if (mapped.length > 0) setIdItemPosition(mapped[0].value);
      });
    } else {
      setDataItemPositionSelect([]);
      setIdItemPosition(null);
    }
  }, [inventoryCode]);

  // Device CRUD
  const addDevice = () => {
    setDevices((prev) => [...prev, emptyDevice(nextId)]);
    setNextId((prev) => prev + 1);
  };

  // Auto-scroll to newest device
  useEffect(() => {
    if (lastTagRef.current) {
      lastTagRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  }, [devices.length]);

  // Check permission and get employee info on mount
  useEffect(() => {
    repositoryMdm
      .get<MessageResponse<any>>(`/api/v1/ServiceRepair/create?prefix=DV`)
      .then((res) => {
        if (!res?.success) {
          NotificationExtension.Fails(
            "Bạn không có quyền hoặc không lấy được thông tin nhân viên",
          );
        } else {
          setEmployeeInfo(res.data);
          if (res.data?.errorNumber) {
            setErrorNumber(res.data.errorNumber);
          }
        }
      })
      .catch((e) => {
        NotificationExtension.Fails(
          "Bạn không có quyền truy cập hoặc không lấy được thông tin nhân viên",
        );
      });
  }, []);

  const removeDevice = (id: number) => {
    setDevices((prev) => prev.filter((d) => d.id !== id));
  };

  const updateDevice = (id: number, key: keyof DeviceItem, value: any) => {
    setDevices((prev) =>
      prev.map((d) => (d.id === id ? { ...d, [key]: value } : d)),
    );
  };

  const handleSerialSearch = async (deviceId: number, serial: string) => {
    if (!serial) return;

    // Check duplicate
    const isDuplicate = devices.some(
      (d) => d.id !== deviceId && d.serial === serial,
    );
    if (isDuplicate) {
      NotificationExtension.Fails(
        `Mã vạch ${serial} đã bị trùng với máy khác trên phiếu!`,
      );
      updateDevice(deviceId, "serial", "");
      return;
    }

    try {
      const res: any = await repositoryMdm.get(
        `/api/v1/ServiceRepair/get-product-by-barcode?barcode=${serial}`,
      );
      if (res?.success && res?.data) {
        const data = res.data;
        updateDevice(deviceId, "itemId", data.itemId || null);
        updateDevice(deviceId, "itemCode", data.productCode || "");
        updateDevice(deviceId, "productName", data.productName || "");
        NotificationExtension.Success("Đã điền thông tin sản phẩm từ mã vạch");
      } else {
        NotificationExtension.Fails(res?.message || "Không tìm thấy sản phẩm");
      }
    } catch (err) {
      NotificationExtension.Fails("Lỗi khi tìm kiếm thông tin sản phẩm");
    }
  };

  const searchTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  const [searchData, setSearchData] = useState<any[]>([]);

  const handleProductSearch = (query: string) => {
    if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current);
    if (!query || query.length < 2) {
      setSearchData([]);
      return;
    }
    searchTimeoutRef.current = setTimeout(async () => {
      try {
        const res: any = await repositoryMdm.get(
          `/api/v1/ServiceRepair/search-product?keyword=${query}`,
        );
        if (res?.success && res?.data) {
          const opts = res.data.map((item: any) => ({
            value: item.productCode + " - " + item.productName,
            name: item.productName,
            code: item.productCode,
            itemId: item.itemId,
          }));
          setSearchData(opts);
        }
      } catch (e) {
        console.error(e);
      }
    }, 400);
  };

  // Validation checklist
  const hasCust = !!customerData;
  const hasDev = devices.length > 0;
  const hasSerial = hasDev && devices.every((d) => d.serial.trim());
  const hasFault = hasDev && devices.every((d) => d.faultDescription.trim());
  const hasAccessories =
    hasDev && devices.every((d) => d.accessories && d.accessories.trim());
  const hasDate = hasDev && devices.every((d) => !!d.scheduleTime);
  // "Số ngày hẹn trả" bắt buộc nhập và >= 0, "Hẹn trả máy" không được nhỏ hơn ngày hiện tại
  const hasDaysReturn =
    hasDev && devices.every((d) => !isDaysReturnInvalid(d.daysReturn));
  const isScheduleTimeValid =
    hasDev && devices.every((d) => !isScheduleTimeInvalid(d.scheduleTime));
  const hasItemCode = hasDev && devices.every((d) => d.itemCode.trim());
  const hasStatus = hasDev && devices.every((d) => d.testingStatus?.trim());
  const hasQuotation =
    hasDev && devices.every((d) => d.quotation && d.quotation.trim());

  // Vị trí kho phải được bật cờ "Lên bảng kê hàng lỗi" (TBL_DM_ITEM_POSITION.ATTRIBUTE4 = 1),
  // nếu không thì phiếu nhập xong sẽ không hiện trên bảng kê hàng dịch vụ.
  const isItemPositionInvalid =
    !!idItemPosition &&
    Number(
      dataItemPositionSelect.find((i: any) => i.value === idItemPosition)
        ?.attribute4,
    ) !== 1;

  const itemPositionError =
    'Vị trí kho này chưa bật "Lên bảng kê hàng lỗi", hàng nhập vào sẽ không lên bảng kê. Vui lòng chọn vị trí khác hoặc bật cờ trong danh mục vị trí kho!';

  const isFormValid =
    hasDev &&
    hasSerial &&
    hasFault &&
    hasAccessories &&
    hasDate &&
    hasDaysReturn &&
    isScheduleTimeValid &&
    hasItemCode &&
    hasStatus &&
    hasQuotation &&
    !!custName &&
    !!custPhone &&
    !!selectedProvince &&
    !!selectedCommune &&
    !!selectedChannel &&
    !!selectedProcessingMethod &&
    !!selectedCustomerGroup &&
    !!selectedBranch &&
    !!inventoryId &&
    !!idItemPosition &&
    !isItemPositionInvalid;

  // Submit
  const handleSubmit = async (status: string) => {
    if (!custName || !custPhone)
      return NotificationExtension.Fails("Vui lòng nhập thông tin khách hàng!");
    if (!hasDev)
      return NotificationExtension.Fails("Vui lòng thêm ít nhất 1 thiết bị!");
    if (!hasItemCode)
      return NotificationExtension.Fails(
        "Vui lòng chọn sản phẩm hợp lệ từ danh sách!",
      );
    if (!hasSerial)
      return NotificationExtension.Fails(
        "Vui lòng nhập Serial cho tất cả thiết bị!",
      );
    if (!hasFault)
      return NotificationExtension.Fails(
        "Vui lòng nhập Tình trạng lỗi cho tất cả thiết bị!",
      );
    if (!hasAccessories)
      return NotificationExtension.Fails(
        "Vui lòng nhập Phụ kiện nhận kèm cho tất cả thiết bị!",
      );
    if (!hasDate)
      return NotificationExtension.Fails(
        "Vui lòng chọn Ngày hẹn trả cho tất cả thiết bị!",
      );
    if (!hasDaysReturn)
      return NotificationExtension.Fails(DAYS_RETURN_INVALID_MESSAGE);
    if (!isScheduleTimeValid)
      return NotificationExtension.Fails(scheduleTimeInvalidMessage());
    if (!hasStatus)
      return NotificationExtension.Fails(
        "Vui lòng chọn Trạng thái cho tất cả thiết bị!",
      );
    if (!hasQuotation)
      return NotificationExtension.Fails(
        "Vui lòng nhập Chi phí dự kiến cho tất cả thiết bị!",
      );
    if (!idItemPosition)
      return NotificationExtension.Fails("Vui lòng chọn vị trí kho!");
    if (isItemPositionInvalid)
      return NotificationExtension.Fails(itemPositionError);

    const serials = devices.map((d) => d.serial).filter(Boolean);
    if (new Set(serials).size !== serials.length) {
      return NotificationExtension.Fails(
        "Có mã vạch bị trùng lặp trên phiếu. Vui lòng kiểm tra lại!",
      );
    }

    open();
    try {
      const payload = {
        id: "0",
        empId: customerData?.empId,
        requestId: customerData?.id || 0,
        errorNumber,
        dateReceive: new Date().toISOString(),
        inventoryCode,
        note,
        idItemPosition: Number(idItemPosition),
        branchId: selectedBranch
          ? Number(selectedBranch)
          : customerData?.branchId,
        customerGroup: selectedCustomerGroup || customerData?.customerGroup,
        inventoryId,
        custMeeting: custName,
        custPhone: custPhone,
        provinceId: Number(selectedProvince) || null,
        communeId: Number(selectedCommune) || null,
        meetingAddress: custAddress,
        roleId: employeeInfo?.roleId,
        roleName: employeeInfo?.roleName,
        depId: employeeInfo?.departmentId,
        depName: employeeInfo?.depName,
        createByName: employeeInfo?.fullname,
        attribute6: status,
        attribute14: selectedProcessingMethod || null,
        attribute15: selectedChannel || null,
        attribute18: customerData?.id?.toString() || null,
        tblWarrantyReceiveTicketDetailCommands: devices.map((d, idx) => ({
          id: idx,
          itemId: d.itemId || null,
          itemName: d.productName,
          serial: d.serial?.trim(),
          itemCode: d.itemCode,
          warrantyTerm: "",
          orderCode: d.orderCode,
          buyingDate: null,
          amount: d.amount,
          serviceType: d.serviceType,
          scheduleTime: new Date(
            new Date(d.scheduleTime || "").getTime() + 7 * 3600 * 1000,
          ).toISOString(),
          daysReturn: d.daysReturn,
          requestFormDetailId: null,
          attribute1: customerData?.attribute6,
          note: d.faultDescription,
          acessory: d.accessories,
          attribute8: d.quotation,
          attribute6: "CHO_TEST",
        })),
      };

      const res = await repositoryMdm.post<MessageResponse<any>>(
        "/api/v1/ServiceRepair/create-service-repair",
        payload,
      );
      if (res?.success) {
        // Thoát ra danh sách trước; thông báo do màn danh sách bật sau khi nạp xong,
        // vì mỗi request của HttpHelper đều gọi notifications.clean().
        onSaved?.("Tạo phiếu tiếp nhận thành công!");
        onSuccess?.((prev: any) => !prev);
        onClose?.("");
      }
    } catch (e) {
      console.error(e);
    } finally {
      close();
    }
  };
  const handleConfirmSubmit = () => {
    modals.openConfirmModal({
      title: "Xác nhận lưu và nhập kho",
      centered: true,
      children: (
        <div style={{ paddingBottom: 24 }}>
          <Text size="lg" fw={600} ta="center" mb="xs">
            Bạn có chắc chắn các thông tin đã nhập là chính xác?
          </Text>
          <Text
            component="div"
            ta="center"
            size="sm"
            fs="italic"
            c="red"
            fw={500}
          >
            *Lưu ý: Phiếu sẽ tự động nhập kho khi ấn lưu.
          </Text>
        </div>
      ),
      labels: { confirm: "Đồng ý", cancel: "Hủy" },
      onConfirm: () => handleSubmit("DA_TIEP_NHAN"),
    });
  };

  return (
    <Box style={{ background: "#EDF0EF", minHeight: "100vh" }}>
      <LoadingOverlay
        visible={visible}
        zIndex={1000}
        overlayProps={{ blur: 2 }}
      />

      {/* ===== TOP BAR ===== */}
      <div className={styles.topBar}>
        <ActionIcon
          variant="outline"
          color="gray"
          radius="md"
          size={34}
          onClick={() => onClose?.("")}
          style={{ borderColor: "rgba(255,255,255,.22)", color: "#fff" }}
        >
          <IconArrowLeft size={16} />
        </ActionIcon>
        <div className={styles.topBarTitle}>
          <h1>Nhận máy từ khách</h1>
        </div>
        <div className={styles.topBarSpacer} />
      </div>

      {/* ===== META STRIP ===== */}
      <div className={styles.metaStrip}>
        <div className={styles.metaItem}>
          <span className={styles.metaKey}>Ngày nhận</span>
          <span className={styles.metaValue}>
            {new Date().toLocaleString("vi-VN")}
          </span>
        </div>
        <div className={styles.metaItem}>
          <span className={styles.metaKey}>Người nhận</span>
          <span className={styles.metaValue}>
            {employeeInfo?.fullname || "—"}
          </span>
        </div>
        <div className={styles.metaItem}>
          <span className={styles.metaKey}>Phòng ban</span>
          <span className={styles.metaValue}>
            {employeeInfo?.depName || "—"}
          </span>
        </div>

        <div className={styles.metaItem} style={{ marginLeft: "auto" }}>
          <span className={styles.metaKey}>Mã phiếu</span>
          <span
            className={styles.metaValue}
            style={{ color: "#e03131", fontWeight: 700 }}
          >
            {errorNumber || "—"}
          </span>
        </div>
        <div
          style={{
            marginLeft: 16,
            display: "flex",
            gap: 8,
            alignItems: "center",
          }}
        >
          <Button
            radius="md"
            variant="default"
            size="xs"
            onClick={() => handleSubmit("TAO_MOI")}
            disabled={!isFormValid}
          >
            Lưu nháp
          </Button>
          <Button
            radius="md"
            color="teal"
            size="xs"
            leftSection={<IconCheck size={16} />}
            onClick={handleConfirmSubmit}
            disabled={!isFormValid}
          >
            Lưu và nhập kho
          </Button>
        </div>
      </div>

      {/* ===== MAIN LAYOUT ===== */}
      <div className={styles.mainWrap}>
        <div className={styles.mainStack}>
          <Grid>
            {/* --- Left: Khách hàng --- */}
            <Grid.Col span={6}>
              <section className={styles.panel} style={{ height: "100%" }}>
                <div className={styles.panelHead}>
                  <h2>Khách hàng</h2>
                  <span className={styles.panelNote}>
                    Tra theo SĐT, tên, mã khách hàng hoặc mã phiếu
                  </span>
                </div>
                <div className={styles.panelBody}>
                  <Autocomplete
                    size="md"
                    radius="md"
                    placeholder="Số điện thoại, tên khách, mã khách hoặc mã phiếu hẹn"
                    style={{ background: "#F7F9F9", borderRadius: 9 }}
                    data={customerSearchData}
                    value={phoneSearch}
                    onChange={handleCustomerSearch}
                    rightSection={
                      <Tooltip label="Danh sách đăng ký dịch vụ sửa chữa">
                        <ActionIcon
                          variant="light"
                          color="blue"
                          onClick={openRequestListModal}
                        >
                          <IconList size={18} />
                        </ActionIcon>
                      </Tooltip>
                    }
                    onOptionSubmit={(val) => {
                      const found = rawCustomerRes.find(
                        (c) =>
                          `${c.telephoneNumber || ""} - ${c.customerName || "Khách lẻ"}` ===
                          val,
                      );
                      if (found) {
                        setCustomerData(found);
                        setPhoneSearch("");
                      } else {
                        submitCustomerSearch(val);
                      }
                    }}
                  />
                  {!customerData && (
                    <Text size="xs" c="dimmed" mt={8}>
                      Nhập SĐT, tên khách, mã khách hoặc mã phiếu tiếp nhận yêu
                      cầu để tìm khách hàng.
                    </Text>
                  )}
                  <Grid mt="md">
                    <Grid.Col span={4}>
                      <TextInput
                        label="Tên khách hàng"
                        placeholder="Nhập tên khách hàng"
                        size="sm"
                        required
                        value={custName}
                        onChange={(e) => setCustName(e.currentTarget.value)}
                      />
                    </Grid.Col>
                    <Grid.Col span={4}>
                      <TextInput
                        label="Số điện thoại"
                        placeholder="Nhập SĐT"
                        size="sm"
                        required
                        value={custPhone}
                        onChange={(e) => setCustPhone(e.currentTarget.value)}
                      />
                    </Grid.Col>
                    <Grid.Col span={4}>
                      <Select
                        label="Tỉnh / Thành phố"
                        placeholder="Chọn tỉnh/thành phố"
                        size="sm"
                        required
                        data={provinceData}
                        value={selectedProvince}
                        onChange={(val) => {
                          setSelectedProvince(val);
                          setSelectedCommune(null);
                        }}
                        searchable
                        clearable
                        nothingFoundMessage="Không tìm thấy"
                      />
                    </Grid.Col>
                  </Grid>
                  <Grid mt={4}>
                    <Grid.Col span={4}>
                      <Select
                        label="Phường / Xã"
                        placeholder="Chọn phường/xã"
                        size="sm"
                        required
                        data={communeData}
                        value={selectedCommune}
                        onChange={setSelectedCommune}
                        searchable
                        clearable
                        disabled={!selectedProvince}
                        nothingFoundMessage="Không tìm thấy"
                      />
                    </Grid.Col>
                    <Grid.Col span={8}>
                      <TextInput
                        label="Địa chỉ cụ thể"
                        placeholder="Số nhà, đường, ngõ..."
                        size="sm"
                        required
                        value={custAddress}
                        onChange={(e) => setCustAddress(e.currentTarget.value)}
                      />
                    </Grid.Col>
                  </Grid>
                </div>
              </section>
            </Grid.Col>

            {/* --- Right: Thông tin xử lý + Nhập kho tiếp nhận --- */}
            <Grid.Col span={6}>
              <section className={styles.panel} style={{ height: "100%" }}>
                <div className={styles.panelHead}>
                  <h2>Thông tin xử lý</h2>
                  <span className={styles.panelNote}>
                    Chọn nơi lưu trữ máy sau khi nhận
                  </span>
                </div>
                <div className={styles.panelBody}>
                  <Grid>
                    <Grid.Col span={4}>
                      <Select
                        label="Kênh tiếp nhận"
                        placeholder="Chọn kênh tiếp nhận"
                        size="sm"
                        required
                        data={channelData}
                        value={selectedChannel}
                        onChange={setSelectedChannel}
                        searchable
                        clearable
                        nothingFoundMessage="Không tìm thấy"
                      />
                    </Grid.Col>
                    <Grid.Col span={4}>
                      <Select
                        label="Hình thức xử lý"
                        placeholder="Chọn hình thức xử lý"
                        size="sm"
                        required
                        data={processingMethodData}
                        value={selectedProcessingMethod}
                        onChange={setSelectedProcessingMethod}
                        searchable
                        clearable
                        nothingFoundMessage="Không tìm thấy"
                      />
                    </Grid.Col>
                    <Grid.Col span={4}>
                      <Select
                        label="Nhóm khách hàng"
                        placeholder="Chọn nhóm khách hàng"
                        size="sm"
                        required
                        data={customerGroupData}
                        value={selectedCustomerGroup}
                        onChange={setSelectedCustomerGroup}
                        searchable
                        clearable
                        nothingFoundMessage="Không tìm thấy"
                      />
                    </Grid.Col>
                  </Grid>
                  <Text fw={700} size="sm" mt="md" mb={4} c="dark">
                    Nhập kho tiếp nhận
                  </Text>
                  <Grid>
                    <Grid.Col span={4}>
                      {/* Khoá theo chi nhánh mặc định của nhân viên (suy từ phòng ban).
                          Chỉ mở cho chọn tay khi phòng ban chưa gắn chi nhánh nào. */}
                      <Select
                        label="Chi nhánh"
                        placeholder="Chọn chi nhánh"
                        data={branchOptions}
                        size="sm"
                        value={selectedBranch}
                        searchable
                        required
                        clearable={!isBranchLocked}
                        disabled={isBranchLocked}
                        onChange={(val) => {
                          setSelectedBranch(val);
                          setInventoryCode(null);
                          setInventoryId(null);
                          setIdItemPosition(null);
                        }}
                      />
                    </Grid.Col>
                    <Grid.Col span={4}>
                      <Select
                        label="Kho"
                        placeholder="Chọn kho"
                        data={dataInventorySelect}
                        size="sm"
                        value={inventoryCode}
                        searchable
                        clearable
                        disabled={!selectedBranch}
                        required
                        onChange={(val) => {
                          setInventoryCode(val);
                          const found = dataInventorySelect.find(
                            (i: any) => i.value === val,
                          );
                          setInventoryId(found?.inventoryId || null);
                          setIdItemPosition(null);
                        }}
                      />
                    </Grid.Col>
                    <Grid.Col span={4}>
                      <Select
                        label="Vị trí kho"
                        placeholder="Chọn vị trí"
                        size="sm"
                        data={dataItemPositionSelect}
                        value={idItemPosition}
                        required
                        onChange={setIdItemPosition}
                        searchable
                        disabled={!inventoryCode}
                        error={
                          isItemPositionInvalid ? itemPositionError : undefined
                        }
                      />
                    </Grid.Col>
                  </Grid>
                  <Textarea
                    size="sm"
                    minRows={2}
                    mt="md"
                    label="Ghi chú nội bộ"
                    placeholder="Dặn dò của khách, cam kết đã trao đổi, rủi ro đã thông báo…"
                    value={note}
                    onChange={(e) => setNote(e.currentTarget.value)}
                  />
                </div>
              </section>
            </Grid.Col>
          </Grid>

          {/* --- Panel: Thiết bị nhận --- */}
          <section className={styles.panel}>
            <div className={styles.panelBody}>
              {deviceViewMode === "card" && (
                <Flex direction="column" gap="md">
                  {devices.map((device, idx) => (
                    <article
                      key={device.id}
                      className={styles.deviceTag}
                      ref={idx === devices.length - 1 ? lastTagRef : undefined}
                    >
                      {/* Stub */}
                      <div className={styles.tagStub}>
                        <span className={styles.tagStubHole} />
                        <span className={styles.tagStubNo}>
                          {String(idx + 1).padStart(2, "0")}
                        </span>
                        <span className={styles.tagStubWord}>Máy</span>
                      </div>
                      {/* Body */}
                      <div className={styles.tagBody}>
                        <div className={styles.tagTop}>
                          <span className={styles.tagLabel}>
                            Máy {String(idx + 1).padStart(2, "0")}
                          </span>
                          <Box ml="auto">
                            <Tooltip label="Bỏ máy này">
                              <ActionIcon
                                variant="subtle"
                                color="red"
                                size="sm"
                                onClick={() => removeDevice(device.id)}
                              >
                                <IconTrash size={14} />
                              </ActionIcon>
                            </Tooltip>
                          </Box>
                        </div>

                        <Grid>
                          <Grid.Col span={5}>
                            <Autocomplete
                              label="Tên sản phẩm"
                              placeholder="Nhập tên hoặc mã SP để tìm..."
                              required
                              size="sm"
                              data={searchData}
                              value={device.productName}
                              onChange={(val) => {
                                updateDevice(device.id, "productName", val);
                                handleProductSearch(val);
                              }}
                              onOptionSubmit={(val) => {
                                const found = searchData.find(
                                  (s) => s.value === val,
                                );
                                if (found) {
                                  updateDevice(
                                    device.id,
                                    "itemId",
                                    found.itemId,
                                  );
                                  updateDevice(
                                    device.id,
                                    "productName",
                                    found.name,
                                  );
                                  updateDevice(
                                    device.id,
                                    "itemCode",
                                    found.code,
                                  );
                                }
                              }}
                            />
                          </Grid.Col>
                          <Grid.Col span={3}>
                            <TextInput
                              label="Mã sản phẩm"
                              placeholder="Mã SP"
                              required
                              size="sm"
                              readOnly
                              value={device.itemCode}
                            />
                          </Grid.Col>
                          <Grid.Col span={4}>
                            <TextInput
                              label="Serial / IMEI"
                              placeholder="Quét mã hoặc nhập tay"
                              required
                              size="sm"
                              value={device.serial}
                              onChange={(e) =>
                                updateDevice(
                                  device.id,
                                  "serial",
                                  e.currentTarget.value.toUpperCase(),
                                )
                              }
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  e.preventDefault();
                                  handleSerialSearch(device.id, device.serial);
                                }
                              }}
                              styles={{ input: { fontFamily: "monospace" } }}
                            />
                          </Grid.Col>
                        </Grid>

                        <Grid>
                          <Grid.Col span={5}>
                            <Box>
                              <Text className={styles.fieldLabel}>
                                Loại dịch vụ
                                <span className={styles.required}>*</span>
                              </Text>
                              <SegmentedControl
                                size="xs"
                                radius="md"
                                fullWidth
                                data={[
                                  "Bảo hành",
                                  "Sửa có phí",
                                  "Đổi trả",
                                  "Kiểm tra",
                                ]}
                                value={device.serviceType}
                                onChange={(val) =>
                                  updateDevice(device.id, "serviceType", val)
                                }
                                color="teal"
                              />
                            </Box>
                          </Grid.Col>
                          <Grid.Col span={4}>
                            <TextInput
                              label="Số hoá đơn"
                              placeholder="Không bắt buộc"
                              size="sm"
                              value={device.orderCode}
                              onChange={(e) =>
                                updateDevice(
                                  device.id,
                                  "orderCode",
                                  e.currentTarget.value,
                                )
                              }
                            />
                          </Grid.Col>
                          <Grid.Col span={3}>
                            <NumberInput
                              label="Số lượng"
                              size="sm"
                              min={1}
                              value={device.amount}
                              onChange={(val) =>
                                updateDevice(device.id, "amount", val || 1)
                              }
                            />
                          </Grid.Col>
                        </Grid>

                        <Textarea
                          label="Tình trạng khách báo"
                          required
                          size="sm"
                          minRows={2}
                          placeholder="Máy không lên nguồn, có tiếng kêu khi khởi động…"
                          value={device.faultDescription}
                          onChange={(e) =>
                            updateDevice(
                              device.id,
                              "faultDescription",
                              e.currentTarget.value,
                            )
                          }
                        />

                        <Grid>
                          <Grid.Col span={4}>
                            <Select
                              label="Trạng thái"
                              required
                              size="sm"
                              placeholder="Chọn trạng thái"
                              data={["Chờ test"]}
                              value={device.testingStatus || null}
                              onChange={(val) =>
                                updateDevice(
                                  device.id,
                                  "testingStatus",
                                  val || "",
                                )
                              }
                            />
                          </Grid.Col>
                          <Grid.Col span={4}>
                            <TextInput
                              label="Phụ kiện nhận kèm"
                              placeholder="VD: Sạc, chuột, túi chống sốc..."
                              size="sm"
                              required
                              value={device.accessories}
                              onChange={(e) =>
                                updateDevice(
                                  device.id,
                                  "accessories",
                                  e.currentTarget.value,
                                )
                              }
                            />
                          </Grid.Col>
                          <Grid.Col span={4}>
                            <TextInput
                              label="Chi phí dự kiến"
                              placeholder="Nhập chi phí dự kiến"
                              size="sm"
                              required
                              value={device.quotation}
                              onChange={(e) =>
                                updateDevice(
                                  device.id,
                                  "quotation",
                                  e.currentTarget.value,
                                )
                              }
                            />
                          </Grid.Col>
                        </Grid>

                        <Grid>
                          <Grid.Col span={4}>
                            <DatePickerInput
                              label="Hẹn trả máy"
                              placeholder="Chọn ngày"
                              size="sm"
                              required
                              locale="vi"
                              valueFormat="DD/MM/YYYY"
                              minDate={minScheduleDate()}
                              error={
                                hasScheduleTimeError(device.scheduleTime)
                                  ? "Hẹn trả máy không được nhỏ hơn ngày hiện tại"
                                  : null
                              }
                              value={
                                device.scheduleTime
                                  ? new Date(device.scheduleTime)
                                  : null
                              }
                              onChange={(date) => {
                                updateDevice(
                                  device.id,
                                  "scheduleTime",
                                  date ? startOfDay(date).toISOString() : null,
                                );
                                updateDevice(
                                  device.id,
                                  "daysReturn",
                                  date ? diffDaysFromBase(date) : null,
                                );
                              }}
                            />
                          </Grid.Col>
                          <Grid.Col span={3}>
                            <NumberInput
                              label="Số ngày hẹn trả"
                              size="sm"
                              placeholder="—"
                              required
                              value={device.daysReturn ?? ""}
                              min={0}
                              startValue={0}
                              allowLeadingZeros={false}
                              allowDecimal={false}
                              allowNegative={false}
                              clampBehavior="none"
                              error={
                                hasDaysReturnError(device.daysReturn)
                                  ? "Số ngày hẹn trả phải lớn hơn hoặc bằng 0"
                                  : null
                              }
                              onChange={(val) => {
                                const numVal =
                                  typeof val === "number" && !Number.isNaN(val)
                                    ? val
                                    : null;
                                updateDevice(device.id, "daysReturn", numVal);
                                updateDevice(
                                  device.id,
                                  "scheduleTime",
                                  numVal !== null
                                    ? dateFromDays(numVal).toISOString()
                                    : null,
                                );
                              }}
                            />
                          </Grid.Col>
                        </Grid>
                      </div>
                    </article>
                  ))}
                </Flex>
              )}

              {deviceViewMode === "table" && (
                <Box style={{ overflowX: "auto", paddingBottom: 16 }}>
                  <Table
                    withTableBorder
                    withColumnBorders
                    verticalSpacing="sm"
                    striped
                  >
                    <Table.Thead>
                      <Table.Tr>
                        <Table.Th
                          style={{ minWidth: 200, whiteSpace: "nowrap" }}
                        >
                          Tên sản phẩm{" "}
                          <span className={styles.required}>*</span>
                        </Table.Th>
                        <Table.Th
                          style={{ minWidth: 120, whiteSpace: "nowrap" }}
                        >
                          Mã SP <span className={styles.required}>*</span>
                        </Table.Th>
                        <Table.Th
                          style={{ minWidth: 150, whiteSpace: "nowrap" }}
                        >
                          Serial / IMEI{" "}
                          <span className={styles.required}>*</span>
                        </Table.Th>
                        <Table.Th
                          style={{ minWidth: 140, whiteSpace: "nowrap" }}
                        >
                          Loại dịch vụ{" "}
                          <span className={styles.required}>*</span>
                        </Table.Th>
                        <Table.Th
                          style={{ minWidth: 120, whiteSpace: "nowrap" }}
                        >
                          Số hoá đơn
                        </Table.Th>
                        <Table.Th
                          style={{ minWidth: 80, whiteSpace: "nowrap" }}
                        >
                          SL
                        </Table.Th>
                        <Table.Th
                          style={{ minWidth: 250, whiteSpace: "nowrap" }}
                        >
                          Tình trạng khách báo{" "}
                          <span className={styles.required}>*</span>
                        </Table.Th>
                        <Table.Th
                          style={{ minWidth: 130, whiteSpace: "nowrap" }}
                        >
                          Trạng thái <span className={styles.required}>*</span>
                        </Table.Th>
                        <Table.Th
                          style={{ minWidth: 200, whiteSpace: "nowrap" }}
                        >
                          Phụ kiện nhận kèm{" "}
                          <span className={styles.required}>*</span>
                        </Table.Th>
                        <Table.Th
                          style={{ minWidth: 150, whiteSpace: "nowrap" }}
                        >
                          Chi phí dự kiến{" "}
                          <span className={styles.required}>*</span>
                        </Table.Th>
                        <Table.Th
                          style={{ minWidth: 110, whiteSpace: "nowrap" }}
                        >
                          Số ngày hẹn trả{" "}
                          <span className={styles.required}>*</span>
                        </Table.Th>
                        <Table.Th
                          style={{ minWidth: 140, whiteSpace: "nowrap" }}
                        >
                          Hẹn trả máy <span className={styles.required}>*</span>
                        </Table.Th>
                        <Table.Th
                          style={{
                            width: 60,
                            minWidth: 60,
                            position: "sticky",
                            right: 0,
                            backgroundColor: "white",
                            zIndex: 2,
                            borderLeft: "1px solid var(--mantine-color-gray-3)",
                          }}
                        ></Table.Th>
                      </Table.Tr>
                    </Table.Thead>
                    <Table.Tbody>
                      {devices.map((device, idx) => (
                        <Table.Tr key={device.id}>
                          <Table.Td>
                            <Autocomplete
                              placeholder="Tên hoặc mã..."
                              required
                              size="xs"
                              data={searchData}
                              value={device.productName}
                              onChange={(val) => {
                                updateDevice(device.id, "productName", val);
                                handleProductSearch(val);
                              }}
                              onOptionSubmit={(val) => {
                                const found = searchData.find(
                                  (s) => s.value === val,
                                );
                                if (found) {
                                  updateDevice(
                                    device.id,
                                    "itemId",
                                    found.itemId,
                                  );
                                  updateDevice(
                                    device.id,
                                    "productName",
                                    found.name,
                                  );
                                  updateDevice(
                                    device.id,
                                    "itemCode",
                                    found.code,
                                  );
                                }
                              }}
                            />
                          </Table.Td>
                          <Table.Td>
                            <TextInput
                              placeholder="Mã SP"
                              required
                              size="xs"
                              value={device.itemCode}
                              readOnly
                            />
                          </Table.Td>
                          <Table.Td>
                            <TextInput
                              placeholder="Serial/IMEI"
                              required
                              size="xs"
                              value={device.serial}
                              onChange={(e) =>
                                updateDevice(
                                  device.id,
                                  "serial",
                                  e.currentTarget.value.toUpperCase(),
                                )
                              }
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  e.preventDefault();
                                  handleSerialSearch(device.id, device.serial);
                                }
                              }}
                            />
                          </Table.Td>
                          <Table.Td>
                            <Select
                              size="xs"
                              data={[
                                "Bảo hành",
                                "Sửa có phí",
                                "Đổi trả",
                                "Kiểm tra",
                              ]}
                              value={device.serviceType}
                              onChange={(val) =>
                                updateDevice(
                                  device.id,
                                  "serviceType",
                                  val || "Sửa có phí",
                                )
                              }
                            />
                          </Table.Td>
                          <Table.Td>
                            <TextInput
                              placeholder="Số HĐ"
                              size="xs"
                              value={device.orderCode}
                              onChange={(e) =>
                                updateDevice(
                                  device.id,
                                  "orderCode",
                                  e.currentTarget.value,
                                )
                              }
                            />
                          </Table.Td>
                          <Table.Td>
                            <NumberInput
                              size="xs"
                              min={1}
                              value={device.amount}
                              onChange={(val) =>
                                updateDevice(device.id, "amount", val || 1)
                              }
                            />
                          </Table.Td>
                          <Table.Td>
                            <TextInput
                              placeholder="Mô tả lỗi..."
                              required
                              size="xs"
                              value={device.faultDescription}
                              onChange={(e) =>
                                updateDevice(
                                  device.id,
                                  "faultDescription",
                                  e.currentTarget.value,
                                )
                              }
                            />
                          </Table.Td>
                          <Table.Td>
                            <Select
                              size="xs"
                              placeholder="Chọn trạng thái"
                              data={["Chờ test"]}
                              value={device.testingStatus || null}
                              onChange={(val) =>
                                updateDevice(
                                  device.id,
                                  "testingStatus",
                                  val || "",
                                )
                              }
                            />
                          </Table.Td>
                          <Table.Td>
                            <TextInput
                              placeholder="Phụ kiện..."
                              required
                              size="xs"
                              value={device.accessories}
                              onChange={(e) =>
                                updateDevice(
                                  device.id,
                                  "accessories",
                                  e.currentTarget.value,
                                )
                              }
                            />
                          </Table.Td>
                          <Table.Td>
                            <TextInput
                              placeholder="Nhập chi phí..."
                              size="xs"
                              value={device.quotation}
                              onChange={(e) =>
                                updateDevice(
                                  device.id,
                                  "quotation",
                                  e.currentTarget.value,
                                )
                              }
                            />
                          </Table.Td>
                          <Table.Td>
                            <NumberInput
                              size="xs"
                              placeholder="—"
                              value={device.daysReturn ?? ""}
                              min={0}
                              startValue={0}
                              allowLeadingZeros={false}
                              allowDecimal={false}
                              allowNegative={false}
                              clampBehavior="none"
                              error={
                                hasDaysReturnError(device.daysReturn)
                                  ? "Phải lớn hơn hoặc bằng 0"
                                  : null
                              }
                              onChange={(val) => {
                                const numVal =
                                  typeof val === "number" && !Number.isNaN(val)
                                    ? val
                                    : null;
                                updateDevice(device.id, "daysReturn", numVal);
                                updateDevice(
                                  device.id,
                                  "scheduleTime",
                                  numVal !== null
                                    ? dateFromDays(numVal).toISOString()
                                    : null,
                                );
                              }}
                            />
                          </Table.Td>
                          <Table.Td>
                            <DatePickerInput
                              placeholder="Chọn ngày"
                              size="xs"
                              locale="vi"
                              valueFormat="DD/MM/YYYY"
                              required
                              minDate={minScheduleDate()}
                              error={
                                hasScheduleTimeError(device.scheduleTime)
                                  ? "Không được trước ngày hiện tại"
                                  : null
                              }
                              value={
                                device.scheduleTime
                                  ? new Date(device.scheduleTime)
                                  : null
                              }
                              onChange={(date) => {
                                updateDevice(
                                  device.id,
                                  "scheduleTime",
                                  date ? startOfDay(date).toISOString() : null,
                                );
                                updateDevice(
                                  device.id,
                                  "daysReturn",
                                  date ? diffDaysFromBase(date) : null,
                                );
                              }}
                            />
                          </Table.Td>
                          <Table.Td
                            style={{
                              position: "sticky",
                              right: 0,
                              backgroundColor: "white",
                              zIndex: 1,
                              borderLeft:
                                "1px solid var(--mantine-color-gray-3)",
                              textAlign: "center",
                            }}
                          >
                            <ActionIcon
                              variant="subtle"
                              color="red"
                              size="sm"
                              onClick={() => removeDevice(device.id)}
                            >
                              <IconTrash size={14} />
                            </ActionIcon>
                          </Table.Td>
                        </Table.Tr>
                      ))}
                    </Table.Tbody>
                  </Table>
                </Box>
              )}

              <button
                className={styles.addTagBtn}
                onClick={addDevice}
                style={{ marginTop: 16 }}
              >
                <IconPlus size={16} />
                Thêm máy
              </button>
            </div>
          </section>
        </div>
      </div>

      {/* ===== STICKY FOOTER ===== */}
      <div className={styles.stickyFooter}>
        <div className={styles.stickyFooterLeft}>
          <div className={styles.railCount} style={{ marginBottom: 0 }}>
            <span className={styles.railCountNum}>
              {String(devices.length).padStart(2, "0")}
            </span>
            <span className={styles.railCountLabel}>máy trên phiếu</span>
          </div>
          <ul className={styles.checkListHorizontal}>
            <li
              className={
                !!custName && !!custPhone
                  ? styles.checkItemOk
                  : styles.checkItem
              }
            >
              Có khách hàng
            </li>
            <li className={hasDev ? styles.checkItemOk : styles.checkItem}>
              Có máy
            </li>
            <li className={hasSerial ? styles.checkItemOk : styles.checkItem}>
              Đủ serial
            </li>
            <li className={hasFault ? styles.checkItemOk : styles.checkItem}>
              Đã ghi lỗi
            </li>
            <li
              className={hasAccessories ? styles.checkItemOk : styles.checkItem}
            >
              Có phụ kiện
            </li>
            <li
              className={
                hasDate && hasDaysReturn && isScheduleTimeValid
                  ? styles.checkItemOk
                  : styles.checkItem
              }
            >
              Đã hẹn trả
            </li>
          </ul>
        </div>

        <div className={styles.stickyFooterRight}>
          <Text size="sm" c="dimmed" mr="md">
            In 2 liên: khách giữ 1, kèm máy 1
          </Text>
        </div>
      </div>
    </Box>
  );
};

export default CreateServiceRepairForm;
